import { render, staticRenderFns } from "./MailOptimization.vue?vue&type=template&id=2ac26c74&scoped=true&"
import script from "./MailOptimization.vue?vue&type=script&lang=js&"
export * from "./MailOptimization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac26c74",
  null
  
)

export default component.exports